import React from 'react';

import Header from '../components/utils/Header';


class ForbiddenView extends React.Component {
  render() {
    return (
      <Header title="You are not authorized to view this page, Please contact your system administrator for access." />
    );
  }
}


export default ForbiddenView;
